/* eslint-disable react/no-unescaped-entities */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import vars from 'li-components/lib/styles'

import { _auth, actions } from '../lib'
import { track } from '../util'
import MarketingPanel from './MarketingPanel'

const Container = styled.div`
  .MarketingPanel > div {
    max-width: 700px;
  }

  h1 {
    padding-bottom: 30px;
    margin-top: 0;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.3;
    color: ${vars.brandPrimary};
    text-align: center;
    border-bottom: 1px solid ${vars.grayLighter};
  }

  h2 {
    font-size: 24px;
    font-weight: 700;
  }

  h3 {
    margin-bottom: 30px;
    font-size: 21px;
    font-weight: 700;
    word-wrap: break-word;
  }

  small {
    display: inline-block;
    margin-top: 50px;
    margin-bottom: 10px;
    font-size: 92%;
    color: ${vars.grayLight};
  }

  a {
    color: ${vars.brandPrimary};
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
      cursor: pointer;
    }
  }
`

export class VerifyEmail extends Component {
  static propTypes = {
    email: PropTypes.string,
    registrationType: PropTypes.string,
    authSendVerification: PropTypes.func.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
  }

  componentWillMount() {
    return _auth
      .logout()
      .then(() => {
        if (!this.props.email) {
          this.context.router.replace('/login')
        }
      })
      .catch(e => console.error(e))
  }

  onSendVerificationClick = e => {
    track({ event: 'resendVerificationEmailClick' })
    this.sendVerification(e)
  }

  sendVerification = e => {
    if (e) e.preventDefault()
    const { email, authSendVerification } = this.props
    authSendVerification(email)
  }

  render() {
    const { email, registrationType } = this.props

    return (
      <Container className="VerifyEmail">
        <MarketingPanel>
          <h1>
            You've signed up for&nbsp;
            {registrationType === 'demo' && <span>a&nbsp;</span>}
            <span className="text-nowrap">Label Insight</span>
            {registrationType === 'demo' && <span>&nbsp;demo</span>}!
          </h1>
          <h2>Now, go check your email:</h2>
          <h3>{email}</h3>
          <p>
            We just sent you a link that verifies your email address. Click it
            so we know you're not a robot (no offense to robots).
          </p>
          {registrationType === 'pro' && (
            <p>
              Someone will be contacting you shortly to get you set up with your
              license.
            </p>
          )}
          <small>
            Didn't get it? Check your spam folder or
            <a href="" onClick={this.onSendVerificationClick}>
              &nbsp;click here
            </a>
            &nbsp;to resend it.
          </small>
        </MarketingPanel>
      </Container>
    )
  }
}

export default connect(
  (state, props) => {
    let email = ''

    if (state.registration && state.registration.email) {
      email = state.registration.email
    } else if (state.auth.loginData.email) {
      email = state.auth.loginData.email
    } else if (state.auth.userData.email) {
      email = state.auth.userData.email
    }

    return {
      email,
      registrationType: props.routeParams.registrationType,
    }
  },
  dispatch => ({
    authSendVerification: email =>
      dispatch(actions.authSendVerification(email)),
  })
)(VerifyEmail)



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/VerifyEmail.js